import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './editcipgrouppage.cssmodule.scss';
import { Radio, FormGroup, Panel, Button, Accordion} from 'react-bootstrap';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import UserSelect from '../Shared/UserSelect';
import Select from 'react-select';
import { Link } from 'react-router';
var NotificationSystem = require('react-notification-system');
import {FormattedDate} from 'react-intl';
import * as constants from '../../constants';

class EditCipGroupPage extends React.Component {
  constructor(props) {
    super(props);
    const { groupId } = props;
    const currentCipGroup = props.currentCipGroup.Group;
    const Members = props.currentCipGroup.Members;
    this.state = {
      groupId: groupId,
      currentCipGroup : {...currentCipGroup},
      Members : [...Members],
      memberToAddId : 0,
      openTransactions : false,
      transaction : {
        Amount : 0.0,
        Description : '',
        Created : new Date()
      }
      ,
      hasCipGroup : (groupId || groupId >= 0)
    }
  }

  componentDidMount() {
    const { groupId } = this.props;
    const currentCipGroup = this.props.currentCipGroup.Group;
    const Members = this.props.currentCipGroup.Members;
    this.setState({
      groupId: groupId,
      currentCipGroup : {...currentCipGroup},
      Members : [...Members],
      hasCipGroup : (groupId || groupId >= 0)
    });
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentDidUpdate(prevProps) {

  }

  componentWillReceiveProps(nextProps) { 
    const { groupId } = nextProps;
    const currentCipGroup = nextProps.currentCipGroup.Group;
    const Members = nextProps.currentCipGroup.Members;
    this.setState({
      groupId: groupId,
      currentCipGroup : {...currentCipGroup},
      Members : [...Members],
      hasCipGroup : (groupId || groupId >= 0)
    });
  }

  handleInputChange(propertyName, event){
    var value = typeof event === 'object' ? event.target.value : event;
    if(propertyName === 'IsActive'){
       value = event.target.checked ? true : false;
    }
    let currentCipGroup = Object.assign(this.state.currentCipGroup, 
          {[propertyName] : value}
    );
    this.setState({
      currentCipGroup : currentCipGroup
    });
  }

  onSelectManager(manager){
    let currentCipGroup = Object.assign(this.state.currentCipGroup, 
          { CipGroupManagerId : manager ? manager.Id : null}
    );
    this.setState({
      currentCipGroup : currentCipGroup
    });
  }

  handleDepartmentSelect(department){
    let currentCipGroup = Object.assign(this.state.currentCipGroup, 
          { CipGroupDepartmentId : department.Id}
    );
    this.setState({
      currentCipGroup : currentCipGroup
    });
  }

  handleRemoveMember(memberId){
    const { groupId } = this.props;
    const { actions } = this.props;
    actions.removeCipMemberAction(groupId, memberId);
  }

  onSelectMember(member){
    this.setState({
      memberToAddId : member ? member.Id : 0
    });
  }

  handleAddMember(){
    const { groupId } = this.props;
    const { actions } = this.props;
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };

    const memberId = this.state.memberToAddId;
    const existingMembers = this.props.currentCipGroup.Members;
    var alreadyAMember =  false;
    existingMembers.forEach((m) => {
        alreadyAMember = (alreadyAMember || m.Id == memberId);
    });
    if(!alreadyAMember){
      actions.addCipMemberAction(groupId, memberId).then(()=> {
        this.setState({
          memberToAddId : -1
        });
      }, 
      (resp) => {
        this._notificationSystem.addNotification({
          title : t("Failed"),
          message: t('ADD_MEMEBER_FAILED', resp),
          level: 'error',
          position : 'br'
        });
      });
    }else{
      this._notificationSystem.addNotification({
          title : t("Failed"),
          message: t('USER_ALREADY_IN_GROUP'),
          level: 'warning',
          position : 'br'
      });
       this.setState({
          memberToAddId : -1
        });
    }
  }

  saveCipGroupClick(){
      const { groupId } = this.props;
      const { actions } = this.props;
      const hasCipGroup = groupId;
      const {intl} = this.props;
      const t = (message, data = {}) => {
          if(!message) return '';
          return intl.formatMessage({id : message}, data);
      };


      actions.saveCipGroupAction(groupId, this.state.currentCipGroup).then((resp) =>{
        if(resp.value && !hasCipGroup){
          this.props.router.push('/cipGroup/' + resp.value.Id); 
          this._notificationSystem.addNotification({
              title : t("Success"),
              message: t('NEW_CI-GROUP-CREATED', {Id : resp.value.Id}),
              level: 'success',
              position : 'br'
          });
        }else{
          this._notificationSystem.addNotification({
              title : t("Success"),
              message: t('SAVE_CI-GROUP-OK'),
              level: 'success',
              position : 'br'
          });
        }
        /*else{
          this.props.router.push('/cipGroups');
        }*/
      }, (error) => {
           this._notificationSystem.addNotification({
              title : t("Failed"),
              message: t(error.Message),
              level: 'error',
              position : 'br'
          });
      });
  }

  doTransaction(isWithdraw){
     var transactionType = isWithdraw ? constants.TRANSACTION_WITHDRAW_TYPE : constants.TRANSACTION_DEPOSIT_TYPE;
     var transaction = this.state.transaction;
     const { groupId } = this.props;
     const { actions } = this.props;
     const {intl} = this.props;
    const t = (message, data = {}) => {
      if(!message) return '';
      return intl.formatMessage({id : message}, data);
    };

     Object.assign(transaction, {
        TransactionType : transactionType,
        CipGroupId : groupId
     });
     actions.saveCipTransactionAction(groupId, transaction).then(() => {
         this._notificationSystem.addNotification({
            title : t("Success"),
            message: t('TRANSACTION_OK'),
            level: 'success',
            position : 'br'
        });
        actions.fetchCipGroupAction(groupId).then(() => {
          actions.fetchCipTransactionsAction(groupId);
          actions.fetchCipMembersAction(groupId);
        });
        this.setState({
          transaction : {
            Amount : 0.0,
            Description : '',
            Created : new Date()
          }
        });
     },
     (resp)=>{
        this._notificationSystem.addNotification({
            title : t("Failed"),
            message: t('TRANSACTION_FAIL', resp),
            level: 'error',
            position : 'br'
        });
     });
  }

  handleTransactionChange(propertyName, event){
    var transaction = this.state.transaction;
    var value = typeof event === 'object' ? event.target.value : event;
    transaction = Object.assign(transaction, 
          {[propertyName] : value}
    );
    this.setState({
        transaction : transaction
    });
  }

  canWidthdraw(transaction){
      if(!transaction || !this.props.currentCipGroup){
        return false;
      }
      const max = this.props.currentCipGroup.Group.Account.Amount;
      return transaction.Description && transaction.Amount > 0 && transaction.Amount <= max;
  }
  
  
  canDeposit(transaction){
      if(!transaction || !this.props.currentCipGroup){
        return false;
      }
      return transaction.Description && transaction.Amount > 0;
  }

  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    const { groupId } = this.props;
    const { cipDepartments } = this.props;
    const currentCipGroup = this.props.currentCipGroup.Group;
    const transactions = this.props.currentCipGroup.Transactions ? this.props.currentCipGroup.Transactions : [];
    const managerName = (currentCipGroup.CipGroupManager ? currentCipGroup.CipGroupManager.DisplayName : '');
    
    const stateCipGroup = this.state.currentCipGroup;
    const Members = this.state.Members;
    const transaction = this.state.transaction;

    const { authInfo } = this.props;
    const { IsAdmin } = authInfo;
    const Authorized = IsAdmin || (authInfo.LocalInfo && authInfo.LocalInfo.Id == stateCipGroup.CipGroupManagerId);
    
    return (
       <div className="container editcipgrouppage-component" styleName="editcipgrouppage-component">
        <NotificationSystem ref="notificationSystem" />
        <Panel header={t('CIP Group') + ' #' + groupId} className="brand-panel">
          <div className="row">
            <div className="col-md-5">
              <form className="form-condensed">
                  <div className="form-group">
                      <label>{t('Name')} :</label>
                      <input className="form-control" disabled={!Authorized} value={stateCipGroup.Title || ''} onChange={this.handleInputChange.bind(this, 'Title')}/>
                  </div>
                  <div className="form-group">
                      <label>{t('Coach name')} :</label>
                      <input disabled={!Authorized} className="form-control" value={stateCipGroup.CipGroupCoachName || '' } onChange={this.handleInputChange.bind(this, 'CipGroupCoachName')}/>
                  </div>
                  
                  {
                    this.state.hasCipGroup && 
                    (<div className="form-group">
                      <label>{t('ACCOUNT_SUM')} :</label>
                      <p className="form-control-static"><h3 style={{marginTop:'0px', marginBottom:'5px'}}>{currentCipGroup.Account ? currentCipGroup.Account.Amount : 0}</h3></p>
                    </div>
                    )
                  }
                  <div className="form-group">
                      <label>{t('Manager')} :</label>
                      <UserSelect disabled={!IsAdmin} userId={stateCipGroup.CipGroupManagerId} onSelectUser={this.onSelectManager.bind(this)}/>
                  </div>
                  {
                    false &&
                    <div className="form-group">
                          <label>{t('Department')} :</label>
                          <Select
                            disabled={!Authorized}
                            value={stateCipGroup.CipGroupDepartmentId} 
                            options={cipDepartments.Departments} onChange={this.handleDepartmentSelect.bind(this)}
                          />
                    </div>
                  }

                  <div className="checkbox">
                      <label><input disabled={!IsAdmin} type="checkbox" checked={stateCipGroup.IsActive || false} onChange={this.handleInputChange.bind(this, 'IsActive')}/>
                      {t('Is Active')}
                      </label>
                  </div>
                  {
                    Authorized &&
                    <button disabled={!stateCipGroup.Title || !stateCipGroup.CipGroupManagerId || false} type="button" onClick={this.saveCipGroupClick.bind(this)} className="btn btn-default btn-brand pull-right">
                      {t('Save')}
                      </button>
                  }
                  <br />
                  <br />
              </form>
            </div>
            <div className="col-md-7">
                
            {
              this.state.hasCipGroup &&
              (
                  <Accordion>
                    { IsAdmin && 
                      <Panel header={t('Deposit or withdraw money')} eventKey="1" className="brand-panel">
                        <form className="form-horizontal">
                            <div className="form-group">
                              <label className="col-sm-3 control-label">{t('ACCOUNT_SUM')}</label>
                              <div className="col-sm-9">
                                 <div className="form-control-static"><h3 style={{marginTop:'0px', marginBottom:'5px'}}>{currentCipGroup.Account ? currentCipGroup.Account.Amount : 0}</h3></div>
                              </div>
                            </div>
                            <div className={(transaction.Amount > 0 ? 'has-success' : 'has-error') + ' form-group'}>
                              <label className="col-sm-3 control-label">{t('DEPOSIT_WITHDRAW_AMOUNT')}</label>
                              <div className="col-sm-9">
                                <input type="number"  value={transaction.Amount} className="form-control" min="0" max={currentCipGroup.Account} onChange={this.handleTransactionChange.bind(this, "Amount")}/>
                              </div>
                            </div>
                            <div className={(transaction.Description ? 'has-success' : 'has-error') + ' form-group'} >
                              <label className="col-sm-3 control-label">{t('Description')}</label>
                              <div className="col-sm-9">
                                <textarea rows="4" value={transaction.Description} className="form-control"  onChange={this.handleTransactionChange.bind(this, "Description")}/>
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="col-sm-offset-3 col-sm-9">
                                <button type="button" disabled={!this.canWidthdraw.bind(this)(transaction)} className="btn btn-default btn-brand" onClick={this.doTransaction.bind(this,true)}>{t('Withdraw')}</button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
                                <button type="button" disabled={!this.canDeposit.bind(this)(transaction)} className="btn btn-default btn-brand" onClick={this.doTransaction.bind(this,false)}>{t('Deposit')}</button>
                              </div>
                            </div>
                          </form>
                      </Panel>
                    }

                    <Panel header={t('Group members')} eventKey="2" className="brand-panel">
                        <table className="table table-condensed table-bordered">
                          <thead>
                            <tr>
                                <th>#</th>
                                <th>{t('Account')}</th>
                                <th>{t('Name')}</th>
                                {Authorized && 
                                  <th>{t('Remove')}</th>
                                }
                            </tr> 
                          </thead>
                          <tbody>
                            {
                              (Members).map((m, idx) => 
                                (<tr key={m.Id}>
                                    <td><Link to={"/user/" + m.Id}>{m.Id}</Link></td>
                                    <td>{m.Account}</td>
                                    <td>{m.DisplayName}</td>
                                    { Authorized &&
                                      <td><button className="btn btn-default btn-danger btn-xs" onClick={this.handleRemoveMember.bind(this, m.Id)}><i className="glyphicon glyphicon-remove"/></button></td>
                                    }
                                </tr>)
                              )
                            }
                          </tbody>
                        </table>
                        {
                          Authorized &&
                          <table style={{width:"100%"}}>
                            <thead>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{minWidth : '200px'}}>
                                  <UserSelect userId={this.state.memberToAddId} onSelectUser={this.onSelectMember.bind(this)}/>
                                </td>
                                <td style={{paddingLeft : '5px'}}>
                                  <button disabled={!this.state.memberToAddId} onClick={this.handleAddMember.bind(this)} className="btn btn-default btn-brand pull-left">
                                    {t('Add')}
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        }
                    </Panel>
                    <Panel header={t('Group transactions')} eventKey="3" className="brand-panel">
                      <table className="table table-condensed table-bordered">
                          <thead>
                            <tr>
                                <th>#</th>
                                <th>{t('Amount')}</th>
                                <th>{t('Description')}</th>
                                <th>{t('Created by')}</th>
                                <th>{t('Created date')}</th>
                            </tr> 
                          </thead>
                          <tbody>
                            {
                              (transactions).map((t, idx) => 
                                (<tr className={t.TransactionType == 3 ? 'danger' : 'success'} key={t.Id}>
                                    <td>{t.Id}</td>
                                    <td>{t.Amount}</td>
                                    <td>{t.Description}</td>
                                    <td>{t.CreatedBy ? t.CreatedBy.DisplayName : ''}</td>
                                    <td><FormattedDate value={t.Created}/></td>
                                </tr>)
                              )
                            }
                          </tbody>
                        </table>
                    </Panel>
                  </Accordion>
              )
          }
              </div>

            </div>
        </Panel>
      </div>
    );
  }
}

EditCipGroupPage.displayName = 'EditCipGroupPage';
EditCipGroupPage.propTypes = {};
EditCipGroupPage.defaultProps = {};
export default injectIntl(cssmodules(EditCipGroupPage, styles));




// WEBPACK FOOTER //
// ./components/CipGroups/EditCipGroupPage.js